// registerServiceWorker.js
// Registers the Workbox-generated service worker for offline support and caching
import { logger } from './utils/logger';

// Create a custom event for service worker updates
const serviceWorkerUpdatedEvent = new Event('serviceWorkerUpdated');

// Track if a new version is waiting
let isUpdateAvailable = false;

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then(registration => {
          // Registration successful
          logger.log('ServiceWorker registration successful:', registration.scope);
          
          // Check for updates on page load
          registration.update().catch(err => {
            logger.error('ServiceWorker update check failed:', err);
          });
          
          // Handle updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            logger.log('ServiceWorker update found, installing...');
            
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New content is available, notify the user
                  logger.log('ServiceWorker: New version available');
                  isUpdateAvailable = true;
                  document.dispatchEvent(serviceWorkerUpdatedEvent);
                } else {
                  // First time install
                  logger.log('ServiceWorker: Content is cached for offline use');
                }
              }
            });
          });
        })
        .catch(error => {
          // Registration failed
          logger.error('ServiceWorker registration failed:', error);
        });
      
      // Handle controller change (when new SW takes over)
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        logger.log('ServiceWorker: Controller changed');
      });
    });
  }
}

// Force refresh to get latest version
export function forceUpdate() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        if (registration.waiting) {
          // Send message to service worker to skip waiting
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        } else {
          registration.update();
        }
      }
      
      // Reload the page to get the latest version
      window.location.reload(true);
    });
  } else {
    // Fallback to regular refresh if service worker is not supported
    window.location.reload(true);
  }
}

// Check if an update is available
export function isUpdateWaiting() {
  return isUpdateAvailable;
}
